"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GdprBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var PRIVACY_NOTICE_URL = services_1.resourcesHelper.PRIVACY_NOTICE_URL;
var GdprBanner = /** @class */ (function (_super) {
    __extends(GdprBanner, _super);
    function GdprBanner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GdprBanner.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "banner gdpr-info-banner banner-info", children: (0, jsx_runtime_1.jsxs)("div", { className: "banner-text info-banner-text", children: [(0, jsx_runtime_1.jsx)("strong", { className: "gdpr-your-data-title", children: "Your data " }), (0, jsx_runtime_1.jsx)("br", {}), "Before we get started, \u00A0", (0, jsx_runtime_1.jsx)("a", { className: "p-0", href: PRIVACY_NOTICE_URL, target: "_blank", id: "personal-info-use", children: "view how we\u2019ll use your info" })] }) }));
    };
    return GdprBanner;
}(plugin_journey_1.WidgetBase));
exports.GdprBanner = GdprBanner;
//# sourceMappingURL=GdprBanner.js.map